document.addEventListener('cart:updated', async function (evt) {
	const { items, original_total_price } = evt.detail.cart;
	await handleAutomaticProductByPrice(items, original_total_price);
	await handleAutomaticProductByCollection(items);
});

function handleAutomaticProductByPrice(cartItems, totalPrice) {
	const totalCart = totalPrice / 100;
	const automaticProductElement = document.getElementById('automatic-product');
	if (!automaticProductElement) {
		return;
	}
	const { minPriceThreshold, autoProductVariantId } = automaticProductElement.dataset;
	if (!minPriceThreshold || !autoProductVariantId) {
		return;
	}
	const automaticProductByPriceData = checkIfAutomaticProductExist(
		cartItems,
		'_automatic_product_by_price'
	);

	if (!automaticProductByPriceData && totalCart >= Number(minPriceThreshold)) {
		const variantData = {
			items: [
				{
					id: autoProductVariantId,
					quantity: 1,
					properties: {
						_automatic_product_by_price: true,
					},
				},
			],
		};
		return addAutomaticProduct(variantData);
	}

	if (automaticProductByPriceData && totalCart < Number(minPriceThreshold)) {
		// Assume `updateItem` exists in theme.js to update the cart item quantity
		updateItem(automaticProductByPriceData.key, 0);
	}
}

function handleAutomaticProductByCollection(cartItems) {
	const discountCollectionElement = document.getElementById('discounted-collection');
	if (!discountCollectionElement) {
		return;
	}
	const { collectionQuantity, collectionAutoProductId } = discountCollectionElement.dataset;
	if (!(collectionQuantity && collectionAutoProductId)) {
		return;
	}
	const automaticProductByCollectioneData = checkIfAutomaticProductExist(
		cartItems,
		'_automatic_product_by_collection'
	);
	const { collection } = JSON.parse(discountCollectionElement.textContent);

	let quantityByCollectionInCart = 0;
	for (let i = 0; i < cartItems.length; i++) {
		const cartElement = cartItems[i];
		// Check if the cart variant_id exists in the collection object
		if (
			collection[cartElement.variant_id] &&
			!cartElement.properties._automatic_product_by_collection
		) {
			quantityByCollectionInCart += cartElement.quantity;
		}
	}
	if (
		!automaticProductByCollectioneData &&
		quantityByCollectionInCart >= Number(collectionQuantity)
	) {
		const variantData = {
			items: [
				{
					id: collectionAutoProductId,
					quantity: 1,
					properties: {
						_automatic_product_by_collection: true,
					},
				},
			],
		};
		return addAutomaticProduct(variantData);
	}

	if (
		automaticProductByCollectioneData &&
		quantityByCollectionInCart < Number(collectionQuantity)
	) {
		// Assume `updateItem` exists in theme.js to update the cart item quantity
		updateItem(automaticProductByCollectioneData.key, 0);
	}
}

function checkIfAutomaticProductExist(cartItems, type) {
	const automaticProduct = cartItems.find((item) => item.properties?.[type] !== undefined);
	if (!automaticProduct) {
		return;
	}
	return automaticProduct;
}
// Add automaticProduct
async function addAutomaticProduct(variantData) {
	const addItemResponse = await fetch('/cart/add.js', {
		method: 'POST',
		credentials: 'include',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(variantData),
	});

	const {
		items: [addedItem],
	} = await addItemResponse.json();

	const cart = await fetch('/cart.js', {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
		},
	}).then((response) => response.json());

	globalEvents('quick-cart:updated');
	globalEvents('cart:updated', {
		cart,
	});
	globalEvents('confirmation-popup:open', null, {
		product: addedItem,
	});
}
